const approvedWorkspaces = (state = {}, action) => {
    if (action.type === "approvedWorkspaces") {
      return state  =  action.payload;
    }
   else {
      return state;
    }
  };
  export default approvedWorkspaces;
  